// pages/Comedor.jsx
import React, { useState, useEffect } from 'react';
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Space,
  Typography,
  message,
  Tag,
  Tooltip,
  Row,
  Col,
  Badge,
  Statistic,
  Card,
  Divider,
  Alert,
  Spin,
  Drawer,
  Grid,
  Dropdown,
  Menu,
  Avatar,
  List,
  Tabs
} from 'antd';
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  ReloadOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EyeOutlined,
  TeamOutlined,
  ExportOutlined,
  CalendarOutlined,
  CoffeeOutlined,
  HomeOutlined,
  FilterOutlined,
  UserOutlined,
  CheckOutlined,
  CloseOutlined,
  SortAscendingOutlined,
  AppstoreOutlined,
  MenuOutlined,
  DownOutlined,
  UpOutlined,
  MobileOutlined,
  TabletOutlined,
  DesktopOutlined,
  MoreOutlined,
  SettingOutlined,
  InfoCircleOutlined,
  PhoneOutlined,
  MailOutlined,
  WhatsAppOutlined,
  StarOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';

import PageContainer from '../components/PageContainer';
import { BASE_URL } from '../utils/constants';

const { Title, Text } = Typography;
const { Option } = Select;
const { useBreakpoint } = Grid;
const { TabPane } = Tabs;

const Comedor = () => {
  // Estados principales
  const [loading, setLoading] = useState(false);
  const [loadingCheckin, setLoadingCheckin] = useState(false);
  const [data, setData] = useState([]);
  const [selectedGuest, setSelectedGuest] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();
//    const [modalType, setModalType] = useState('view');
  
  // Estados para filtros y búsqueda
  const [searchText, setSearchText] = useState('');
  const [searchLoading, setSearchLoading] = useState(false);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});
  
  // Estados para fechas y servicios
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedService, setSelectedService] = useState('Desayuno');
  
  // Estado para paginación
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 1000000000,
    total: 0,
    checkedIn: 0,
    pending: 0,
    showSizeChanger: true,
    showQuickJumper: true,
    showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} huéspedes`
  });

  // Detectar tamaño de pantalla
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const isTablet = screens.md && !screens.lg;
  const isDesktop = screens.lg;

  // Configuración responsive de columnas
  const mobileColumns = [
    {
      title: 'Hab.',
      dataIndex: 'Habitacion',
      key: 'Habitacion',
      width: 50,
      render: (habitacion, record) => (
        <div style={{ textAlign: 'center' }}>
          <Tag 
            color={record.checkedIn ? "green" : "blue"} 
            style={{ 
              fontWeight: 'bold', 
              fontSize: '12px',
              padding: '2px 6px',
              margin: 0,
              width: '40px',
              textAlign: 'center'
            }}
          >
            {habitacion}
          </Tag>
        </div>
      ),
    },
    {
      title: 'Huésped',
      dataIndex: 'Nombre',
      key: 'Nombre',
      ellipsis: true,
      width: 50,
      render: (nombre, record) => (
        <div style={{ lineHeight: '1.3' }}>
          <div style={{ 
            fontSize: '13px', 
            fontWeight: 500,
            color: record.checkedIn ? '#52c41a' : '#1890ff'
          }}>
            {nombre}
          </div>
          <div style={{ 
            fontSize: '11px', 
            color: '#666',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
            marginTop: '2px'
          }}>
            <span>📋 {record.Regimen}</span>
            <span style={{ margin: '0 4px' }}>•</span>
            <span>{record.Ad}A</span>
            {record.Ni > 0 && <span> {record.Ni}N</span>}
            {record.Bb > 0 && <span> {record.Bb}B</span>}
          </div>
        </div>
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'checkedIn',
      key: 'checkedIn',
      width: 50,
      render: (checkedIn) => (
        checkedIn ? (
          <CheckCircleOutlined 
            style={{ 
              color: '#52c41a', 
              fontSize: '18px',
              padding: '4px'
            }} 
          />
        ) : (
          <CloseCircleOutlined 
            style={{ 
              color: '#ff4d4f', 
              fontSize: '18px',
              padding: '4px'
            }} 
          />
        )
      ),
    },
    {
      title: '',
      key: 'actions',
      width: 80,
      render: (_, record) => (
        <Button
            type={record.checkedIn ? "default" : "primary"}
            danger={record.checkedIn}
            // icon={record.checkedIn ? <CloseOutlined /> : <CheckOutlined />}
            onClick={(e) => {
                e.stopPropagation();
                handleView(record);
            }}
            loading={loadingCheckin}
            size="small"
            style={{
            width: '80px',
            height: '32px',
            padding: '0 8px',
            fontSize: '11px',
            fontWeight: 'bold'
            }}
        >
            {/* {record.checkedIn ? 'SALIR' : 'ENTRAR'} */}
            Ver detalles
        </Button>
        ),
    },
  ];

  const tabletColumns = [
    {
      title: 'Hab.',
      dataIndex: 'Habitacion',
      key: 'Habitacion',
      width: 80,
      render: (habitacion) => (
        <Tag 
          color="blue" 
          style={{ 
            fontWeight: 'bold', 
            fontSize: '12px',
            padding: '4px 8px',
            margin: 0
          }}
        >
          {habitacion}
        </Tag>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'Nombre',
      key: 'Nombre',
      ellipsis: true,
      render: (nombre) => (
        <Text strong style={{ fontSize: '12px' }}>
          {nombre}
        </Text>
      ),
    },
    {
      title: 'Ocupantes',
      key: 'occupants',
      width: 100,
      render: (_, record) => (
        <Space size={2} wrap>
          <Tag color="blue" style={{ margin: 0, fontSize: '10px' }}>{record.Ad}A</Tag>
          {record.Ni > 0 && <Tag color="green" style={{ margin: 0, fontSize: '10px' }}>{record.Ni}N</Tag>}
          {record.Bb > 0 && <Tag color="orange" style={{ margin: 0, fontSize: '10px' }}>{record.Bb}B</Tag>}
        </Space>
      ),
    },
    {
      title: 'Estado',
      dataIndex: 'checkedIn',
      key: 'checkedIn',
      width: 100,
      render: (checkedIn) => (
        checkedIn ? (
          <Badge
            status="success"
            text="En comedor"
            style={{ fontSize: '11px' }}
          />
        ) : (
          <Badge
            status="default"
            text="Pendiente"
            style={{ fontSize: '11px' }}
          />
        )
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 120,
      render: (_, record) => (
        <Space size={4}>
          <Tooltip title="Ver detalles">
            <Button
              type="text"
              icon={<EyeOutlined />}
              size="small"
              onClick={() => handleView(record)}
              style={{ padding: '4px' }}
            />
          </Tooltip>
          <Tooltip title={record.checkedIn ? "Registrar salida" : "Registrar entrada"}>
            <Button
              type={record.checkedIn ? "default" : "primary"}
              icon={record.checkedIn ? <CloseOutlined /> : <CheckOutlined />}
              size="small"
              onClick={() => handleToggleCheckin(record)}
              loading={loadingCheckin}
              style={{ padding: '4px 8px', fontSize: '11px' }}
            >
              {record.checkedIn ? 'Salida' : 'Entrada'}
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  const desktopColumns = [
    {
      title: 'Estado',
      dataIndex: 'checkedIn',
      key: 'checkedIn',
      width: 100,
      sorter: (a, b) => (a.checkedIn ? 1 : 0) - (b.checkedIn ? 1 : 0),
      sortOrder: sortedInfo.columnKey === 'checkedIn' && sortedInfo.order,
      render: (checkedIn) => (
        checkedIn ? (
          <Badge
            status="success"
            text="En comedor"
            style={{ color: '#52c41a', fontWeight: 'bold' }}
          />
        ) : (
          <Badge
            status="default"
            text="Pendiente"
            style={{ color: '#d9d9d9', fontWeight: 'bold' }}
          />
        )
      ),
      filters: [
        { text: 'En comedor', value: true },
        { text: 'Pendiente', value: false },
      ],
      filteredValue: filteredInfo.checkedIn || null,
      onFilter: (value, record) => record.checkedIn === value,
      fixed: 'left',
    },
    {
      title: 'Habitación',
      dataIndex: 'Habitacion',
      key: 'Habitacion',
      width: 100,
      sorter: (a, b) => a.Habitacion - b.Habitacion,
      sortOrder: sortedInfo.columnKey === 'Habitacion' && sortedInfo.order,
      render: (habitacion) => (
        <Tag 
          color="blue" 
          style={{ 
            fontWeight: 'bold', 
            fontSize: '14px',
            padding: '4px 8px'
          }}
        >
          {habitacion}
        </Tag>
      ),
    },
    {
      title: 'Nombre',
      dataIndex: 'Nombre',
      key: 'Nombre',
      width: 200,
      sorter: (a, b) => a.Nombre?.localeCompare(b.Nombre || '') || 0,
      sortOrder: sortedInfo.columnKey === 'Nombre' && sortedInfo.order,
      render: (nombre) => (
        <div style={{ maxWidth: 200 }}>
          <Text strong style={{ fontSize: '13px' }}>
            {nombre}
          </Text>
        </div>
      ),
    },
    {
      title: 'Ocupantes',
      key: 'occupants',
      width: 120,
      render: (_, record) => (
        <Space size={4} wrap>
          <Tag color="blue" style={{ margin: 0 }}>{record.Ad}A</Tag>
          {record.Ni > 0 && <Tag color="green" style={{ margin: 0 }}>{record.Ni}N</Tag>}
          {record.Bb > 0 && <Tag color="orange" style={{ margin: 0 }}>{record.Bb}B</Tag>}
        </Space>
      ),
    },
    {
      title: 'Régimen',
      dataIndex: 'Regimen',
      key: 'Regimen',
      width: 120,
      sorter: (a, b) => a.Regimen?.localeCompare(b.Regimen || '') || 0,
      sortOrder: sortedInfo.columnKey === 'Regimen' && sortedInfo.order,
      render: (regimen) => (
        <Tag color="purple" style={{ margin: 0 }}>{regimen}</Tag>
      ),
    },
    {
      title: 'Acciones',
      key: 'actions',
      width: 150,
      fixed: 'right',
      render: (_, record) => (
        <Space>
          <Tooltip title="Ver detalles">
            <Button
              type="default"
              icon={<EyeOutlined />}
              size="small"
              onClick={() => handleView(record)}
            />
          </Tooltip>
          
          <Tooltip title={record.checkedIn ? "Registrar salida" : "Registrar entrada"}>
            <Button
              type={record.checkedIn ? "default" : "primary"}
              icon={record.checkedIn ? <CloseOutlined /> : <CheckOutlined />}
              size="small"
              onClick={() => handleToggleCheckin(record)}
              loading={loadingCheckin}
            >
              {record.checkedIn ? 'Salida' : 'Entrada'}
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

    const mobileStyles = `
        @media (max-width: 768px) {
            .ant-table-row {
            padding: 8px 4px !important;
            }
            
            .ant-table-cell {
            padding: 8px 4px !important;
            }
            
            .ant-btn-sm {
            min-height: 32px;
            min-width: 60px;
            }
            
            /* Mejorar área de toque para filas */
            .ant-table-tbody > tr > td {
            padding-top: 12px !important;
            padding-bottom: 12px !important;
            }
            
            /* Feedback táctil */
            .ant-table-row:active {
            background-color: #f0f5ff !important;
            }
        }
        `;

        
  // Seleccionar columnas según dispositivo
  const getColumns = () => {
    if (isMobile) return mobileColumns;
    if (isTablet) return tabletColumns;
    return desktopColumns;
  };

  // Cargar datos iniciales
  useEffect(() => {
    fetchComedorData();
  }, [selectedDate, selectedService, pagination.current, pagination.pageSize]);

  // Función principal para obtener datos
  const fetchComedorData = async (params = {}) => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      
      const queryParams = {
        fecha: selectedDate.format('DD/MM/YYYY'),
        servicio: selectedService,
        page: params.current || pagination.current,
        pageSize: params.pageSize || pagination.pageSize,
        search: searchText,
        sortField: params.sortField || sortedInfo.field || 'Habitacion',
        sortOrder: params.sortOrder || (sortedInfo.order === 'descend' ? 'DESC' : 'ASC'),
        ...params
      };
      
      // Añadir filtros
      if (filteredInfo.checkedIn) {
        queryParams.checkedIn = filteredInfo.checkedIn[0];
      }
      
      const response = await axios.get(`${BASE_URL}/api/comedor`, {
        headers: { Authorization: `Bearer ${token}` },
        params: queryParams
      });

      if (response.data.success) {
        setData(response.data.data);
        setPagination(prev => ({
          ...prev,
          current: response.data.pagination.currentPage || 1,
          pageSize: response.data.pagination.pageSize || prev.pageSize,
          total: response.data.pagination.totalRecords || response.data.data.length,
          checkedIn: response.data.pagination.checkedIn || 0,
          pending: response.data.pagination.pending || 0
        }));
      } else {
        message.error(response.data.error || 'Error al cargar los datos');
        setData([]);
      }
      
    } catch (error) {
      console.error('❌ Error cargando datos del comedor:', error);
      message.error('Error de conexión');
      setData([]);
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };

  const handleTableChange = (newPagination, filters, sorter) => {
    setFilteredInfo(filters);
    setSortedInfo(sorter);
    
    const params = {
      current: newPagination.current,
      pageSize: newPagination.pageSize,
      sortField: sorter.field,
      sortOrder: sorter.order === 'ascend' ? 'DESC' : 'ASC'
    };
    
    setPagination(prev => ({
      ...prev,
      current: newPagination.current,
      pageSize: newPagination.pageSize
    }));
    
    fetchComedorData(params);
  };

  // Función para ver detalles del huésped
  const handleView = async (record) => {
    // setModalType('view');
    
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/comedor/guest/detail`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          numReserva: record.NumReserva,
          linea: record.Linea,
          numOcupante: record.NumOcupante,
          fecha: selectedDate.format('DD/MM/YYYY'),
          servicio: selectedService
        }
      });
      
      if (response.data.success) {
        setSelectedGuest(response.data.data);
        if (isMobile) {
          setDrawerVisible(true);
        } else {
          setModalVisible(true);
        }
      } else {
        message.error(response.data.error || 'Error al cargar detalles');
      }
    } catch (error) {
      console.error('Error cargando detalles:', error);
      message.error('Error de conexión');
    }
  };

  // Función para alternar check-in/check-out
  const handleToggleCheckin = async (record) => {
    setLoadingCheckin(true);
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.post(
        `${BASE_URL}/api/comedor/checkin`,
        {
          numReserva: record.NumReserva,
          linea: record.Linea,
          numOcupante: record.NumOcupante,
          servicio: selectedService,
          fecha: selectedDate.format('DD/MM/YYYY'),
          checkIn: !record.checkedIn
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        // Actualizar el estado local
        const updatedData = data.map(item => {
          if (
            item.NumReserva === record.NumReserva &&
            item.Linea === record.Linea &&
            item.NumOcupante === record.NumOcupante
          ) {
            return { ...item, checkedIn: !record.checkedIn };
          }
          return item;
        });

        setData(updatedData);
        
        // Actualizar estadísticas
        const checkedInCount = updatedData.filter(item => item.checkedIn).length;
        setPagination(prev => ({
          ...prev,
          checkedIn: checkedInCount,
          pending: updatedData.length - checkedInCount
        }));
        
        message.success(
          !record.checkedIn 
            ? `Check-in realizado para ${record.Nombre}` 
            : `Check-out realizado para ${record.Nombre}`
        );
        
        // Cerrar modal/drawer si está abierto
        if (isMobile) {
          setDrawerVisible(false);
        } else {
          setModalVisible(false);
        }
      } else {
        message.error(response.data.error || 'Error al actualizar');
      }
    } catch (error) {
      console.error('Error actualizando check-in:', error);
      message.error('Error de conexión');
    } finally {
      setLoadingCheckin(false);
    }
  };

  const handleSearch = () => {
    if (searchText.trim() === '') {
      message.warning('Por favor ingrese un término de búsqueda');
      return;
    }
    setSearchLoading(true);
    setPagination({ ...pagination, current: 1 });
    fetchComedorData({ current: 1 });
  };

  const handleResetSearch = () => {
    setSearchText('');
    setFilteredInfo({});
    setSortedInfo({});
    setSearchLoading(false);
    setPagination({ ...pagination, current: 1 });
    fetchComedorData({ current: 1 });
  };

  const handleRefresh = () => {
    fetchComedorData();
    message.success('Datos actualizados');
  };

  const handleExport = async () => {
    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`${BASE_URL}/api/comedor/export`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          fecha: selectedDate.format('DD/MM/YYYY'),
          servicio: selectedService
        }
      });
      
      if (response.data.success) {
        message.info(response.data.message || 'Exportación en desarrollo');
      } else {
        message.error(response.data.error || 'Error al exportar');
      }
    } catch (error) {
      console.error('Error exportando:', error);
      message.error('Error de conexión');
    }
  };

  const serviceOptions = [
    { value: 'Desayuno', label: 'Desayuno', icon: <CoffeeOutlined /> },
    { value: 'Almuerzo', label: 'Almuerzo', icon: <TeamOutlined /> },
    { value: 'Cena', label: 'Cena', icon: <UserOutlined /> },
  ];

  // Componente de búsqueda responsive
  const searchBar = (
    <div style={{ marginBottom: 16 }}>
      <Row gutter={[8, 8]} align="middle">
        <Col xs={24} sm={16} md={18}>
          <Input
            placeholder={isMobile ? "Buscar..." : "Buscar por habitación, nombre, régimen..."}
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: '100%' }}
            onPressEnter={handleSearch}
            allowClear
            onClear={handleResetSearch}
            prefix={<SearchOutlined />}
            size={isMobile ? "small" : "middle"}
          />
        </Col>
        <Col xs={12} sm={4} md={3}>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
            loading={searchLoading}
            size={isMobile ? "small" : "middle"}
            block={isMobile}
          >
            {isMobile ? '' : 'Buscar'}
          </Button>
        </Col>
        <Col xs={12} sm={4} md={3}>
          <Button
            icon={<ReloadOutlined />}
            onClick={handleResetSearch}
            size={isMobile ? "small" : "middle"}
            block={isMobile}
          >
            {isMobile ? '' : 'Limpiar'}
          </Button>
        </Col>
      </Row>
      {!isMobile && (
        <div style={{ marginTop: 8 }}>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            {pagination.total.toLocaleString()} huéspedes encontrados
          </Text>
        </div>
      )}
    </div>
  );

  // Estadísticas responsive
  const estadisticas = (
    <Row gutter={[8, 8]} style={{ marginBottom: 16 }}>
      <Col xs={8} sm={8} md={8}>
        <Card 
          size="small"
          bodyStyle={{ 
            padding: isMobile ? '8px 4px' : '12px',
            textAlign: 'center'
          }}
          style={{ 
            borderRadius: 8,
            background: 'linear-gradient(135deg, #e6f7ff 0%, #bae7ff 100%)',
            height: '100%'
          }}
        >
          <Statistic
            title={<Text type="secondary" style={{ fontSize: isMobile ? '10px' : '12px' }}>Total</Text>}
            value={pagination.total}
            prefix={<TeamOutlined style={{ fontSize: isMobile ? '14px' : '16px' }} />}
            valueStyle={{ 
              color: '#1890ff',
              fontSize: isMobile ? '18px' : '22px'
            }}
          />
        </Card>
      </Col>
      <Col xs={8} sm={8} md={8}>
        <Card 
          size="small"
          bodyStyle={{ 
            padding: isMobile ? '8px 4px' : '12px',
            textAlign: 'center'
          }}
          style={{ 
            borderRadius: 8,
            background: 'linear-gradient(135deg, #f6ffed 0%, #d9f7be 100%)',
            height: '100%'
          }}
        >
          <Statistic
            title={<Text type="secondary" style={{ fontSize: isMobile ? '10px' : '12px' }}>En Comedor</Text>}
            value={pagination.checkedIn}
            prefix={<CheckCircleOutlined style={{ fontSize: isMobile ? '14px' : '16px' }} />}
            valueStyle={{ 
              color: '#52c41a',
              fontSize: isMobile ? '18px' : '22px'
            }}
          />
        </Card>
      </Col>
      <Col xs={8} sm={8} md={8}>
        <Card 
          size="small"
          bodyStyle={{ 
            padding: isMobile ? '8px 4px' : '12px',
            textAlign: 'center'
          }}
          style={{ 
            borderRadius: 8,
            background: 'linear-gradient(135deg, #fff7e6 0%, #ffd591 100%)',
            height: '100%'
          }}
        >
          <Statistic
            title={<Text type="secondary" style={{ fontSize: isMobile ? '10px' : '12px' }}>Pendientes</Text>}
            value={pagination.pending}
            prefix={<CloseCircleOutlined style={{ fontSize: isMobile ? '14px' : '16px' }} />}
            valueStyle={{ 
              color: '#fa8c16',
              fontSize: isMobile ? '18px' : '22px'
            }}
          />
        </Card>
      </Col>
    </Row>
  );

  // Panel de filtros responsive
  const filterPanel = (
    <Card
      style={{
        marginBottom: 16,
        borderRadius: 8,
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
      }}
      bodyStyle={{ padding: isMobile ? '12px' : '16px' }}
    >
      <Row gutter={[12, 12]} align="middle">
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" style={{ width: '100%' }} size="small">
            <Text strong style={{ fontSize: isMobile ? '12px' : '14px' }}>
              <CalendarOutlined /> {isMobile ? 'Fecha' : 'Fecha del servicio'}
            </Text>
            <DatePicker
              value={selectedDate}
              onChange={setSelectedDate}
              format="DD/MM/YYYY"
              style={{ width: '100%' }}
              size={isMobile ? "small" : "middle"}
              allowClear={false}
            />
          </Space>
        </Col>
        
        <Col xs={24} sm={12} md={8}>
          <Space direction="vertical" style={{ width: '100%' }} size="small">
            <Text strong style={{ fontSize: isMobile ? '12px' : '14px' }}>
              <CoffeeOutlined /> {isMobile ? 'Servicio' : 'Tipo de servicio'}
            </Text>
            <Select
              value={selectedService}
              onChange={setSelectedService}
              style={{ width: '100%' }}
              size={isMobile ? "small" : "middle"}
              options={serviceOptions.map(opt => ({
                value: opt.value,
                label: (
                  <Space size={4}>
                    {opt.icon}
                    <span>{isMobile ? opt.value : opt.label}</span>
                  </Space>
                )
              }))}
            />
          </Space>
        </Col>
        
        <Col xs={24} md={8}>
          <Space direction="vertical" style={{ width: '100%' }} size="small">
            <Text strong style={{ fontSize: isMobile ? '12px' : '14px', opacity: 0 }}>
              Acciones
            </Text>
            <Button
              type="primary"
              icon={<ReloadOutlined />}
              onClick={handleRefresh}
              block
              size={isMobile ? "small" : "middle"}
            >
              {isMobile ? 'Actualizar' : 'Actualizar Datos'}
            </Button>
          </Space>
        </Col>
      </Row>
    </Card>
  );

  // Badge de dispositivo

  return (
    <>
      <PageContainer
        title={isMobile ? "Comedor" : "Control Comedor"}
        subtitle={
          isMobile 
            ? `${selectedService} - ${selectedDate.format('DD/MM')}` 
            : `${pagination.total} huéspedes - ${selectedService} - ${selectedDate.format('DD/MM/YYYY')}`
        }
        icon={<TeamOutlined />}
        loading={loading}
        onRefresh={handleRefresh}
        // badgeCount={pagination.pending}
        badgeStatus="warning"
        badgeText={`${pagination.pending} pendientes`}
        extra={
          <Space wrap>
            
            {!isMobile && (
              <>
                <Button
                  icon={<ExportOutlined />}
                  onClick={handleExport}
                  size={isMobile ? "small" : "middle"}
                >
                  {isTablet ? 'Exportar' : 'Exportar datos'}
                </Button>
                {/* <Tag color="blue" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
                  <strong>{pagination.total.toLocaleString()}</strong> huéspedes
                </Tag> */}
              </>
            )}
          </Space>
        }
        cardStyle={{
          borderRadius: '12px',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)'
        }}
      >
        {/* Panel de filtros */}
        {filterPanel}
        
        {/* Estadísticas */}
        {estadisticas}
        
        {/* Barra de búsqueda */}
        {searchBar}
        
        {/* Tabla responsive */}
        <Card
          style={{
            borderRadius: 8,
            boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
            marginBottom: 16
          }}
          bodyStyle={{ padding: isMobile ? '8px' : '16px' }}
        >
          <div style={{ 
            marginBottom: isMobile ? 8 : 16,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 8
          }}>
            <Space wrap>
              <Text strong style={{ fontSize: isMobile ? '14px' : '16px' }}>
                <FilterOutlined /> {isMobile ? 'Huéspedes' : 'Lista de Huéspedes'}
              </Text>
              <Tag color="blue" style={{ margin: 0, fontSize: isMobile ? '11px' : '12px' }}>
                {pagination.total} registros
              </Tag>
            </Space>
            
            {isMobile ? (
              <Space>
                <Text type="secondary" style={{ fontSize: '11px' }}>
                  {selectedDate.format('DD/MM')} • {selectedService}
                </Text>
              </Space>
            ) : (
              <Space>
                <Text type="secondary" style={{ fontSize: '12px' }}>
                  {selectedDate.format('DD/MM/YYYY')} • {selectedService}
                </Text>
                <Button
                  size="small"
                  onClick={handleRefresh}
                  icon={<ReloadOutlined />}
                />
              </Space>
            )}
          </div>

          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <Spin size="large" />
              <div style={{ marginTop: 16 }}>
                <Text type="secondary">Cargando huéspedes...</Text>
              </div>
            </div>
          ) : data.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px 20px' }}>
              <Alert
                message="No hay datos"
                description={
                  searchText 
                    ? `No se encontraron resultados para "${searchText}"`
                    : 'No hay huéspedes registrados para esta fecha y servicio'
                }
                type="info"
                showIcon
                style={{ maxWidth: 500, margin: '0 auto' }}
              />
              {searchText && (
                <Button 
                  type="link" 
                  onClick={handleResetSearch}
                  style={{ marginTop: 16 }}
                >
                  Limpiar búsqueda
                </Button>
              )}
            </div>
          ) : (
            <Table
              columns={getColumns()}
              dataSource={data}
              rowKey={(record) => `${record.NumReserva}-${record.Linea}-${record.NumOcupante}`}
              loading={loading}
              onChange={handleTableChange}
              pagination={{
                ...pagination,
                size: isMobile ? "small" : "default",
                simple: isMobile,
                showLessItems: isMobile,
                pageSizeOptions: isMobile ? ['10', '20', '50'] : ['10', '20', '50', '100'],
                showSizeChanger: !isMobile
              }}
              // scroll={{ 
              //   x: isMobile ? 400 : isTablet ? 600 : 800,
              //   y: isMobile ? 400 : isTablet ? 500 : 600
              // }}
              size={isMobile ? "small" : "middle"}
              locale={{
                emptyText: 'No se encontraron huéspedes'
              }}
              onRow={(record) => ({
                onClick: () => handleToggleCheckin(record),
                style: {
                  cursor: 'pointer',
                  backgroundColor: record.checkedIn ? '#f6ffed' : 'white',
                  fontSize: isMobile ? '12px' : '14px'
                }
              })}
              rowClassName={(record) => record.checkedIn ? 'checked-in-row' : ''}
            />
          )}
        </Card>

        {/* Footer móvil */}
        {isMobile && (
          <div style={{ 
            position: 'fixed', 
            bottom: 0, 
            left: 0, 
            right: 0, 
            background: 'white',
            padding: '8px 12px',
            borderTop: '1px solid #f0f0f0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            zIndex: 1000
          }}>
            <Space size={4}>
              <Tag color="blue" style={{ margin: 0, fontSize: '11px' }}>
                {pagination.checkedIn} en comedor
              </Tag>
              <Tag color="orange" style={{ margin: 0, fontSize: '11px' }}>
                {pagination.pending} pendientes
              </Tag>
            </Space>
            <Button
              type="primary"
              size="small"
              icon={<ExportOutlined />}
              onClick={handleExport}
            >
              Exportar
            </Button>
          </div>
        )}
      </PageContainer>

      {/* Modal para desktop/tablet */}
      <Modal
        title={
          <Space>
            <UserOutlined />
            <Text strong>Detalle del huésped</Text>
          </Space>
        }
        open={modalVisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
        width={isTablet ? 500 : 600}
        centered
      >
        {renderGuestDetail()}
      </Modal>

      {/* Drawer para móvil */}
      <Drawer
        title={
          <Space>
            <UserOutlined />
            <Text strong>Detalle del huésped</Text>
          </Space>
        }
        placement="right"
        onClose={() => setDrawerVisible(false)}
        open={drawerVisible}
        width="100%"
        height="100%"
        style={{ maxWidth: 500 }}
        extra={
          <Button
            type="text"
            icon={<CloseOutlined />}
            onClick={() => setDrawerVisible(false)}
          />
        }
      >
        {renderGuestDetail(true)}
      </Drawer>
    </>
  );

  // Función para renderizar detalles del huésped
  function renderGuestDetail(isMobileView = false) {
    if (!selectedGuest) return <Spin size="large" />;

    return (
      <>
        <Card 
          bordered={false}
          style={{ marginBottom: isMobileView ? 16 : 0 }}
        >
          {isMobileView ? (
            <Tabs defaultActiveKey="info" size="small">
              <TabPane tab="Información" key="info">
                <GuestInfoMobile guest={selectedGuest} />
              </TabPane>
              <TabPane tab="Acciones" key="actions">
                <GuestActionsMobile 
                  guest={selectedGuest} 
                  onToggle={handleToggleCheckin}
                  loading={loadingCheckin}
                />
              </TabPane>
            </Tabs>
          ) : (
            <GuestInfoDesktop guest={selectedGuest} />
          )}
        </Card>

        {!isMobileView && (
          <>
            <Divider />
            <GuestActionsDesktop 
              guest={selectedGuest} 
              onToggle={handleToggleCheckin}
              loading={loadingCheckin}
            />
          </>
        )}
      </>
    );
  }
};

// Componente de información para móvil
const GuestInfoMobile = ({ guest }) => (
  <div style={{ padding: '4px' }}>
    <div style={{ textAlign: 'center', marginBottom: 16 }}>
      <Avatar
        size={64}
        style={{ 
          backgroundColor: guest.checkedIn ? '#52c41a' : '#1890ff',
          marginBottom: 8
        }}
        icon={<UserOutlined />}
      />
      <div style={{ fontSize: '16px', fontWeight: 'bold' }}>{guest.Nombre}</div>
      <div style={{ fontSize: '12px', color: '#666' }}>Habitación {guest.Habitacion}</div>
    </div>

    <List
      size="small"
      dataSource={[
        { label: 'Estado', value: guest.checkedIn ? '✅ En comedor' : '⏳ Pendiente', color: guest.checkedIn ? '#52c41a' : '#fa8c16' },
        { label: 'Régimen', value: guest.Regimen, color: '#722ed1' },
        { label: 'Adultos', value: `${guest.Ad}`, color: '#1890ff' },
        { label: 'Niños', value: `${guest.Ni}`, color: '#52c41a' },
        { label: 'Bebés', value: `${guest.Bb}`, color: '#fa8c16' },
        { label: 'Entrada', value: dayjs(guest.Entrada).format('DD/MM/YYYY'), color: '#13c2c2' },
        { label: 'Salida', value: dayjs(guest.Salida).format('DD/MM/YYYY'), color: '#f5222d' },
        { label: 'Reserva', value: guest.NumReserva, color: '#722ed1' },
      ]}
      renderItem={(item) => (
        <List.Item style={{ padding: '8px 0', borderBottom: '1px solid #f0f0f0' }}>
          <Row style={{ width: '100%' }}>
            <Col span={12}>
              <Text type="secondary" style={{ fontSize: '12px' }}>{item.label}:</Text>
            </Col>
            <Col span={12} style={{ textAlign: 'right' }}>
              <Text strong style={{ color: item.color, fontSize: '12px' }}>{item.value}</Text>
            </Col>
          </Row>
        </List.Item>
      )}
    />

    {(guest.TodoIncluido === 'X' || guest.BebidaIncluida === 'X') && (
      <div style={{ marginTop: 16 }}>
        {guest.TodoIncluido === 'X' && (
          <Alert
            message="Todo Incluido"
            description="Régimen todo incluido activo"
            type="info"
            showIcon
            size="small"
            style={{ marginBottom: 8 }}
          />
        )}
        {guest.BebidaIncluida === 'X' && (
          <Alert
            message="Bebida Incluida"
            description="Bebida incluida en el servicio"
            type="info"
            showIcon
            size="small"
          />
        )}
      </div>
    )}
  </div>
);

// Componente de información para desktop/tablet
const GuestInfoDesktop = ({ guest }) => (
  <Space direction="vertical" style={{ width: '100%' }} size="large">
    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Text strong>Habitación:</Text>
        <div>
          <Tag color="blue" style={{ fontSize: '16px', padding: '4px 8px' }}>
            {guest.Habitacion}
          </Tag>
        </div>
      </Col>
      <Col span={12}>
        <Text strong>Estado:</Text>
        <div>
          {guest.checkedIn ? (
            <Tag color="success" icon={<CheckCircleOutlined />}>
              EN COMEDOR
            </Tag>
          ) : (
            <Tag color="default" icon={<CloseCircleOutlined />}>
              NO ENTRADO
            </Tag>
          )}
        </div>
      </Col>
    </Row>

    <Divider style={{ margin: '8px 0' }} />

    <div>
      <Text strong>Nombre:</Text>
      <div style={{ marginTop: 4 }}>
        <Text style={{ fontSize: '16px' }}>{guest.Nombre}</Text>
      </div>
    </div>

    <Row gutter={[16, 16]}>
      <Col span={8}>
        <Text strong>Adultos:</Text>
        <div>
          <Text strong style={{ fontSize: '16px' }}>{guest.Ad}</Text>
        </div>
      </Col>
      <Col span={8}>
        <Text strong>Niños:</Text>
        <div>
          <Text strong style={{ fontSize: '16px' }}>{guest.Ni}</Text>
        </div>
      </Col>
      <Col span={8}>
        <Text strong>Bebés:</Text>
        <div>
          <Text strong style={{ fontSize: '16px' }}>{guest.Bb}</Text>
        </div>
      </Col>
    </Row>

    <Divider style={{ margin: '8px 0' }} />

    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Text strong>Entrada:</Text>
        <div>
          <Tag>{dayjs(guest.Entrada).format('DD/MM/YYYY')}</Tag>
        </div>
      </Col>
      <Col span={12}>
        <Text strong>Salida:</Text>
        <div>
          <Tag>{dayjs(guest.Salida).format('DD/MM/YYYY')}</Tag>
        </div>
      </Col>
    </Row>

    <Divider style={{ margin: '8px 0' }} />

    <Row gutter={[16, 16]}>
      <Col span={12}>
        <Text strong>Régimen:</Text>
        <div>
          <Tag color="purple">{guest.Regimen}</Tag>
        </div>
      </Col>
      <Col span={12}>
        <Text strong>Reserva:</Text>
        <div>
          <Text type="secondary">{guest.NumReserva}</Text>
        </div>
      </Col>
    </Row>

    {guest.TodoIncluido === 'X' && (
      <Alert
        message="Todo Incluido"
        description="El huésped tiene régimen todo incluido"
        type="info"
        showIcon
      />
    )}

    {guest.BebidaIncluida === 'X' && (
      <Alert
        message="Bebida Incluida"
        description="Bebida incluida en el servicio"
        type="info"
        showIcon
        style={{ marginTop: 8 }}
      />
    )}
  </Space>
);

// Componente de acciones para móvil
const GuestActionsMobile = ({ guest, onToggle, loading }) => (
  <div style={{ padding: '16px' }}>
    <div style={{ textAlign: 'center', marginBottom: 24 }}>
      <Text type="secondary" style={{ fontSize: '12px' }}>
        {guest.checkedIn 
          ? 'El huésped está actualmente en el comedor' 
          : 'El huésped aún no ha entrado al comedor'}
      </Text>
    </div>
    
    <Button
      type={guest.checkedIn ? "primary" : "default"}
      danger={guest.checkedIn}
      icon={guest.checkedIn ? <CloseOutlined /> : <CheckOutlined />}
      onClick={() => onToggle(guest)}
      loading={loading}
      size="large"
      block
      style={{
        height: '48px',
        fontSize: '16px',
        marginBottom: '12px'
      }}
    >
      {guest.checkedIn ? 'Registrar Salida' : 'Registrar Entrada'}
    </Button>
    
    <Button
      type="default"
      icon={<InfoCircleOutlined />}
      block
      style={{ marginBottom: '12px' }}
    >
      Ver información completa
    </Button>
  </div>
);

// Componente de acciones para desktop/tablet
const GuestActionsDesktop = ({ guest, onToggle, loading }) => (
  <div style={{ textAlign: 'center' }}>
    <Space direction="vertical" style={{ width: '100%' }}>
      {guest.checkedIn ? (
        <>
          <Button
            type="primary"
            danger
            icon={<CloseOutlined />}
            onClick={() => onToggle(guest)}
            loading={loading}
            size="large"
            block
          >
            Registrar Salida
          </Button>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            El huésped está actualmente en el comedor
          </Text>
        </>
      ) : (
        <>
          <Button
            type="primary"
            icon={<CheckOutlined />}
            onClick={() => onToggle(guest)}
            loading={loading}
            size="large"
            block
          >
            Registrar Entrada
          </Button>
          <Text type="secondary" style={{ fontSize: '12px' }}>
            El huésped aún no ha entrado al comedor
          </Text>
        </>
      )}
    </Space>
  </div>
);

export default Comedor;